export const FormatCurrency = (value, currencyCode = "USD", locale = "en-US") => {
  if (value == null || value === "") return "";
  
  let formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  formatted = formatted.replace(/(\p{Sc})(\d)/u, "$1 $2");

  return formatted;
};